module.exports = __webpack_public_path__ + "static/scale-model-of-nashtrash-tours-in-nashville-tennessee-c9c5dca308488cbd7e56b3d16d40c1ee.png";